import { Fragment } from 'react'
import { Route } from 'react-router'
import { authenticatedRoutes } from '../config/route-registry'

export function renderSimpleRoutes() {
  return authenticatedRoutes.map(({ path, List, Detail, Create, Edit }) => (
    <Fragment key={path}>
      <Route path={path} element={<List />} />
      {Detail && <Route path={`${path}/:id`} element={<Detail />} />}
      {Create && <Route path={`${path}/create`} element={<Create />} />}
      {Edit && <Route path={`${path}/:id/edit`} element={<Edit />} />}
    </Fragment>
  ))
}
